(() => {
  document.addEventListener('click', (event) => {
    const faqButton = event.target.closest('[data-faq-button]');
    if (faqButton) {
      const item = faqButton.closest('.faq-item');
      if (!item) return;
      const isOpen = item.classList.toggle('is-open');
      faqButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      const panel = item.querySelector('.faq-item__answer');
      if (panel) panel.hidden = !isOpen;
    }

    const filterButton = event.target.closest('[data-catalog-filter]');
    if (filterButton) {
      const section = filterButton.closest('[data-catalog]');
      if (!section) return;
      const filter = (filterButton.dataset.catalogFilter || 'all').toLowerCase();
      section.querySelectorAll('[data-catalog-filter]').forEach((button) => button.classList.toggle('is-active', button === filterButton));
      section.querySelectorAll('[data-catalog-card]').forEach((card) => {
        const category = (card.dataset.category || '').toLowerCase();
        card.hidden = filter !== 'all' && category !== filter;
      });
    }

    const mobileToggle = event.target.closest('[data-mobile-toggle]');
    if (mobileToggle) {
      const nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      const nextHidden = !nav.hasAttribute('hidden');
      if (nextHidden) nav.setAttribute('hidden', ''); else nav.removeAttribute('hidden');
      mobileToggle.setAttribute('aria-expanded', nextHidden ? 'false' : 'true');
    }
  });
})();
